import { FileTextIcon } from 'lucide-react'

import { Button } from '@/components/ui'
import type { ReasonAction } from './model/types'
import { UploadStatementsButton } from './UploadStatementsButton'

// The one button that helps with an amber reason: open the statement, or upload the missing one.
export const ReasonActionButton = ({ action }: { action: ReasonAction }) => {
  if (action.kind === 'upload_statement') {
    return <UploadStatementsButton label={action.label} />
  }
  return (
    <Button
      theme="outline"
      size="sm"
      className="h-7 font-medium text-blue-7"
      asChild
    >
      <a href={action.fileUrl} target="_blank" rel="noreferrer">
        <FileTextIcon />
        {action.label}
      </a>
    </Button>
  )
}
